var _defs, _metadata, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpdates(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXl: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsDc: "http://purl.org/dc/elements/1.1/",
    viewBox: "703.6718 -831 63.5779 65",
    width: 63.5779,
    height: 65,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    id: "Gradient",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00bfec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0084a2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Obj_Gradient",
    xlHref: "#Gradient",
    gradientTransform: "translate(759.7355 -835.8798) rotate(123) scale(89.1406)"
  }))), _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, " Produced by OmniGraffle 7.12.1 \n    ", /*#__PURE__*/React.createElement("dcDate", null, "2020-10-27 13:23:07 +0000"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Canvas_1",
    strokeDasharray: "none",
    fill: "none",
    stroke: "none",
    strokeOpacity: 1,
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("title", null, "Canvas 1"), /*#__PURE__*/React.createElement("g", {
    id: "Canvas_1: Layer 1"
  }, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("g", {
    id: "Graphic_90"
  }, /*#__PURE__*/React.createElement("title", null, "path5056"), /*#__PURE__*/React.createElement("path", {
    d: "M 735.9524 -830.9995 C 732.3771 -830.9782 728.7637 -830.3671 725.2552 -829.1161 C 711.2212 -824.1101 702.3611 -810.1242 703.8305 -795.2968 C 705.2999 -780.4694 716.7322 -768.49515 731.4758 -766.3414 C 746.2193 -764.1877 760.6004 -772.3922 766.2497 -786.1795 C 767.0157 -787.9767 766.7547 -790.0472 765.5667 -791.5981 C 764.3786 -793.149 762.44755 -793.9401 760.51285 -793.6685 C 758.5782 -793.3969 756.93955 -792.1047 756.2244 -790.2866 C 752.4404 -781.0517 742.917 -775.6196 733.0418 -777.0621 C 723.1666 -778.505 715.5966 -786.4341 714.6124 -796.3654 C 713.6282 -806.2968 719.4954 -815.5576 728.8954 -818.9106 C 735.7606 -821.3593 743.1609 -820.1748 748.8045 -816.1199 L 743.3719 -812.5105 L 767.2497 -800.6729 L 767.0938 -803.167 L 765.5903 -827.2726 L 758.2234 -822.3778 C 752.1475 -827.9809 744.15045 -831.0466 735.9524 -830.9995 Z",
    fill: "url(#Obj_Gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Line_97"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 751.0003,
    y1: -802,
    x2: 735,
    y2: -788,
    stroke: "#00c372",
    strokeOpacity: 0.80078125,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Line_98"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 726,
    y1: -797,
    x2: 735,
    y2: -788,
    stroke: "#00c372",
    strokeOpacity: 0.80078125,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdates);
export default __webpack_public_path__ + "static/media/updates.34b2226126c3233d1dba46c180dd2713.svg";
export { ForwardRef as ReactComponent };